import { convertLngLatBoundsToLatLngBounds } from '../convert.js';
export class MaplibreMoveEvent {
    #rawEvent;
    constructor(rawEvent) {
        this.#rawEvent = rawEvent;
    }
    get type() {
        switch (this.#rawEvent.type) {
            case 'move':
                return 'move';
            case 'movestart':
                return 'movestart';
            case 'moveend':
                return 'moveend';
            default:
                throw new Error('maplibre move event not handled');
        }
    }
    preventDefault() { }
    get bounds() {
        return convertLngLatBoundsToLatLngBounds(this.#rawEvent.target.getBounds());
    }
    static convert(callback) {
        return (e) => callback(new MaplibreMoveEvent(e));
    }
    static isType(eventType) {
        return (eventType === 'move' ||
            eventType === 'movestart' ||
            eventType === 'moveend');
    }
    static convertType(eventType) {
        return eventType;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW92ZS5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJldmVudHMvbW92ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsaUNBQWlDLEVBQUUsTUFBTSxlQUFlLENBQUE7QUFFakUsTUFBTSxPQUFPLGlCQUFpQjtJQUM3QixTQUFTLENBQVU7SUFFbkIsWUFBWSxRQUFrQjtRQUM3QixJQUFJLENBQUMsU0FBUyxHQUFHLFFBQVEsQ0FBQTtJQUMxQixDQUFDO0lBRUQsSUFBSSxJQUFJO1FBQ1AsUUFBUSxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksRUFBRSxDQUFDO1lBQzdCLEtBQUssTUFBTTtnQkFDVixPQUFPLE1BQU0sQ0FBQTtZQUNkLEtBQUssV0FBVztnQkFDZixPQUFPLFdBQVcsQ0FBQTtZQUNuQixLQUFLLFNBQVM7Z0JBQ2IsT0FBTyxTQUFTLENBQUE7WUFDakI7Z0JBQ0MsTUFBTSxJQUFJLEtBQUssQ0FBQyxpQ0FBaUMsQ0FBQyxDQUFBO1FBQ3BELENBQUM7SUFDRixDQUFDO0lBRUQsY0FBYyxLQUFVLENBQUM7SUFFekIsSUFBSSxNQUFNO1FBQ1QsT0FBTyxpQ0FBaUMsQ0FDdkMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsU0FBUyxFQUFFLENBQ2pDLENBQUE7SUFDRixDQUFDO0lBRUQsTUFBTSxDQUFDLE9BQU8sQ0FDYixRQUF3QztRQUV4QyxPQUFPLENBQUMsQ0FBVyxFQUFFLEVBQUUsQ0FBQyxRQUFRLENBQUMsSUFBSSxpQkFBaUIsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBQzNELENBQUM7SUFFRCxNQUFNLENBQUMsTUFBTSxDQUFDLFNBQWlCO1FBQzlCLE9BQU8sQ0FDTixTQUFTLEtBQUssTUFBTTtZQUNwQixTQUFTLEtBQUssV0FBVztZQUN6QixTQUFTLEtBQUssU0FBUyxDQUN2QixDQUFBO0lBQ0YsQ0FBQztJQUVELE1BQU0sQ0FBQyxXQUFXLENBQUMsU0FBb0M7UUFDdEQsT0FBTyxTQUFTLENBQUE7SUFDakIsQ0FBQztDQUNEIn0=